import { ChevronDown, ChevronUp, Users } from 'lucide-react';
import { BookingDetails, ExpandedSections } from '../../types/booking-details.types';

export function ClientSection({
  booking,
  expandedSections,
  toggleSection,
}: {
  booking: BookingDetails;
  expandedSections: ExpandedSections;
  toggleSection: (section: keyof ExpandedSections) => void;
}) {
  const b = booking;

  return (
    <>
      {/* Client Principal */}
      <div className="mb-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-full bg-primary/10 text-primary flex items-center justify-center text-lg font-bold shrink-0">
            {b.client.name.charAt(0)}
          </div>
          <div className="space-y-1 flex-1">
            <p className="font-bold text-slate-900 text-lg">{b.client.name}</p>
            {b.client.company && <p className="text-sm text-slate-500 font-medium">{b.client.company}</p>}
            <div className="text-sm text-slate-600 pt-1 space-y-0.5">
              <p>{b.client.email}</p>
              <p>{b.client.phone}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Participants Additionnels */}
      {b.participants && b.participants.length > 0 && (
        <div>
          <button
            onClick={() => toggleSection('participants')}
            className="flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-primary transition-colors mb-3"
          >
            <Users className="w-4 h-4" />
            Participants ({b.participants.length})
            {expandedSections.participants ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          </button>
          {expandedSections.participants && (
            <div className="space-y-3 pl-6 border-l-2 border-slate-100">
              {b.participants.map((participant, idx) => (
                <div key={idx} className="flex items-start gap-3 p-3 bg-slate-50 rounded-lg">
                  <div className="w-8 h-8 rounded-full bg-secondary/10 text-secondary flex items-center justify-center text-sm font-bold shrink-0">
                    {participant.name.charAt(0)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-slate-900">{participant.name}</p>
                    <p className="text-xs text-slate-500 font-medium">{participant.role}</p>
                    <div className="text-xs text-slate-600 mt-1 space-y-0.5">
                      <p>{participant.email}</p>
                      <p>{participant.phone}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
